import React, { useCallback, useMemo, useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";

import COMMON from "common";
import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";
import { formatCurrency } from "common/format-currency-pattern";
import { AxiosContext } from "contexts/with-interceptor-provider";
import AppTable, { AppTableCell } from "components/app-table";
import AppEmptyState from "components/app-empty-state";

const AppClaimSummary = () => {
	const { id } = useParams();
	const context = useContext(AxiosContext);
	const [data, setData] = useState({ page: 0, size: 10, total: 0, offset: 0, totalElements: 0, prev: false, next: false, items: [] });
	const isEmptyState = useMemo(() => COMMON.TABLE_REQUEST_STATUS.INSTANCE === data.status, [data.status]);

	const onHandleGetList = useCallback(async () => {
		let response = null;

		setData((prev) => ({ ...prev, items: [] }));

		try {
			response = await api.get.claims.summary(id);
		} catch (error) {
			serveRequestErrors(error);
		}

		if (response) {
			setData((prev) => ({ ...prev, items: response, status: !response.length ? COMMON.TABLE_REQUEST_STATUS.INSTANCE : "" }));
		}
	}, [id]);

	const EntitledAmountCell = useCallback(({ row }) => {
		const value = row.original.entitlement == null ? "subject to approval" : formatCurrency(row.original.entitlement);
		return <AppTableCell right value={value} />;
	}, []);

	const BalanceAmountCell = useCallback(({ row }) => {
		const value = row.original.balance == null ? "subject to approval" : formatCurrency(row.original.balance);
		return <AppTableCell right value={value} />;
	}, []);

	//prettier-ignore
	const columns = useMemo(() => [
		{
			Header: "Claim Type",
			accessor: "claimTypeMapped",
			disableSortBy: true,
		},
		{
			Header: () => <div className="table__amount">Entitled Amount (RM)</div>,
			accessor: "entitlement",
			disableSortBy: true,
			Cell: EntitledAmountCell
		},
		{
			Header: () => <div className="table__amount">Balance Amount (RM)</div>,
			accessor: "balance",
			disableSortBy: true,
			Cell: BalanceAmountCell
		},
	], [EntitledAmountCell, BalanceAmountCell]);

	useEffect(() => {
		onHandleGetList();
	}, [onHandleGetList]);

	useEffect(() => {
		return () => {
			context.onHandleCancelRequest(COMMON.ENDPOINT_PATH.CLAIMS.SUMMARY);
		};
	}, [context]);

	return (
		<div className="app-claim-summary">
			{isEmptyState && <AppEmptyState title="No records found" description="You don’t have any records yet" disabledButton />}
			{!isEmptyState && <AppTable columns={columns} pages={data} />}
		</div>
	);
};

export default AppClaimSummary;
